export enum DetailsPanelAllowanceEnum {
    routeSheetTabs = 'routeSheetTabs',

    fullOpenTicketResponsible = 'fullOpenTicketResponsible',

    routeTrazability = 'routeTrazability',

    movementReport = 'movementReport',
    driveHabitsReport = 'driveHabitsReport',
    driveStatisticsReport = 'driveStatisticsReport',
}

export const FULLY_ALLOWED_DETAILS_PANEL: DetailsPanelAllowanceEnum[] = [
    DetailsPanelAllowanceEnum.routeSheetTabs,
    DetailsPanelAllowanceEnum.routeTrazability,
    DetailsPanelAllowanceEnum.movementReport,
    DetailsPanelAllowanceEnum.driveHabitsReport,
    DetailsPanelAllowanceEnum.driveStatisticsReport,
    DetailsPanelAllowanceEnum.fullOpenTicketResponsible
];